import { VesselHoverLabelForm } from './TargetHoverForms/VesselHoverLabelForm';
import { InfoIconTooltip } from '@ais-ui/ui-core';
import React, { useState } from 'react';
import { BaseStationHoverLabelForm } from './TargetHoverForms/BaseStationHoverLabelForm';
import { useLocalization } from '@ais-ui/locale-management';
import { TargetHoverLabelTabs } from './TargetHoverLabelTabs';
import { AtonHoverLabelForm } from './TargetHoverForms/AtonHoverLabelForm';
import { VirtualAtonHoverLabelForm } from './TargetHoverForms/VirtualAtonHoverLabelForm';
import { MethydHoverLabelForm } from './TargetHoverForms/MethydHoverLabelForm';

export function TargetHoverLabelForm() {
  const { messages } = useLocalization();

  const [tab, setTab] = useState<
    'vessel' | 'aton' | 'virtualAton' | 'methyd' | 'baseStation'
  >('vessel');
  return (
    <div>
      <div className="flex justify-between">
        <div className={'flex items-center space-x-1'}>
          <h3 className="text-lg font-medium">
            {tab === 'baseStation'
              ? messages.settingsMapBaseStationHoverTitle
              : tab === 'aton'
              ? messages.settingsMapAtonHoverTitle
              : tab === 'virtualAton'
              ? messages.settingsMapVirtualAtonHoverTitle
              : tab === 'methyd'
              ? messages.settingsMapMethydHoverTitle
              : messages.settingsMapVesselHoverTitle}
          </h3>
          <InfoIconTooltip>
            {messages.settingsMapTargetInfoTooltip}
          </InfoIconTooltip>
        </div>
        <TargetHoverLabelTabs setTab={setTab} tab={tab}></TargetHoverLabelTabs>
      </div>

      {tab === 'baseStation' ? (
        <BaseStationHoverLabelForm></BaseStationHoverLabelForm>
      ) : tab === 'aton' ? (
        <AtonHoverLabelForm></AtonHoverLabelForm>
      ) : tab === 'virtualAton' ? (
        <VirtualAtonHoverLabelForm></VirtualAtonHoverLabelForm>
      ) : tab === 'methyd' ? (
        <MethydHoverLabelForm></MethydHoverLabelForm>
      ) : (
        <VesselHoverLabelForm></VesselHoverLabelForm>
      )}
    </div>
  );
}
